import './GraphSidePanel.css';

import { type FC, memo } from 'react';

import { prop } from '@ipfabric/utils/fp/prop';
import classNames from 'classnames';
import { GraphNetworkViewer } from 'components/Graph/GraphSidePanel/GraphNetworkViewer/GraphNetworkViewer';
import { useGraphContextSelectors } from '../GraphContext';
import { GraphCompareSnapshot } from './GraphCompareSnapshot';
import { GraphPathlookup } from './GraphPathlookup/GraphPathlookup';
import { IntentVerification } from './IntentVerification/IntentVerification';

const BareGraphSidePanelContent: FC = () => {
  const ctxProps = useGraphContextSelectors({
    sidePanel: prop('sidePanel'),
  });

  const renderContent = () => {
    switch (ctxProps.sidePanel.contentId) {
      case 'networkViewer': {
        return <GraphNetworkViewer />;
      }
      case 'compareSnapshot': {
        return <GraphCompareSnapshot />;
      }
      case 'pathlookup': {
        return <GraphPathlookup />;
      }
      case 'intentVerification': {
        return <IntentVerification />;
      }
      default:
        return null;
    }
  };

  return (
    <div
      className={classNames(
        'graph-side-panel__content',
        'flex flex-col',
        ctxProps.sidePanel.open && 'graph-side-panel__content--open',
      )}
    >
      {renderContent()}
    </div>
  );
};

export const GraphSidePanelContent = memo(BareGraphSidePanelContent);
